<!--订单查询-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container order-query">
      <div v-if="sjopen === true">
        <p style="color: red">{{this.$t('miMember.FOrder.has')}}</p>
      </div>
      <p style="font-weight: 600 ;color: green">{{this.$t('fi.type.ac.e') +'：'}}<span style="color:red;">{{this.canUseF$}}</span></p>
      <el-form size="small" :inline="true" :model="listQuery">
        <!--     单据编号   -->
        <el-form-item size="mini" :label="$t('stStockAlter.receiptNO')">
          <el-input v-model.trim="listQuery.orderNo" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        经销商编号-->
        <el-form-item size="mini" :label="$t('miMemberNetwork.memberNo')">
          <el-input v-model.trim="listQuery.memberNo" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        经销商姓名-->
        <el-form-item size="mini" :label="$t('miMember.name')">
          <el-input v-model.trim="listQuery.name" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        单据类型-->
        <el-form-item size="mini" :label="$t('fiAcInput.orderType')">
          <el-select v-model="listQuery.orderType" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in orderTyleList" :key="role.code" :label="$lt(initDict.orderTyoe,role.title)" :value="role.code" />
          </el-select>
        </el-form-item>
        <!--        结算-->
        <el-form-item size="mini" :label="$t('button.settle')">
          <el-select v-model="listQuery.locked" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in bdPeriodStatusList" :key="role.code" :label="$lt(initDict.bdPeriodStatus,role.title)" :value="role.code" />
          </el-select>
        </el-form-item>
        <!--       期次-->
        <el-form-item v-if="companyCode!=='BD'" size="mini" :label="$t('PoOrder.periodWeek')">
          <el-select v-model="listQuery.periodWeek" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in wWeekList" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="companyCode ==='BD'" size="mini" :label="$t('printReturnList.month')">
          <el-date-picker
              v-model="listQuery.monthStart"
              type="date"
              style="width: 130px"
              value-format="yyyyMM">
          </el-date-picker>-<el-date-picker
              v-model="listQuery.monthEnd"
              type="date"
              style="width: 130px"
              value-format="yyyyMM">
          </el-date-picker>
        </el-form-item>
        <!--          搜索-->

      </el-form>
      <el-button size="mini"  type="primary" :loading="btnloading" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      <el-button size="mini"  type="success" :loading="btnloading" icon="el-icon-s-order" @click="exporttable">{{ $t('corp.common.export') }}</el-button>
      <!--            代办处发货-->
      <el-button v-if="isAgent" type="success" icon="el-icon-check" :loading="btnloading"   size="mini"  @click="SendOut" >{{$t('ps.shipped')}}</el-button>
      <!--            经销商收货-->
      <el-button v-if="!isAgent" type="success" icon="el-icon-check" :loading="btnloading"  size="mini"  @click="PutAway" >{{$t('lm.goods.receipt')}}</el-button>
      <el-table
          :key="tableKey"
          v-loading="listLoading"
          height="400"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
      >
        <el-table-column :selectable="selectable" type="selection" width="45" align="center" />
        <!-- 操作 -->
        <el-table-column :label="$t('sysOperationLog.moduleName')" align="center" class-name="small-padding fixed-width">
          <template slot-scope="{row}">
            <!--          查看-->
            <el-button icon="el-icon-search" size="mini" :loading="btnloading" :title="$t('button.view')" circle @click="handleView(row)" />
            <el-button v-if="row.sendStatus == 0" icon="el-icon-close" :loading="btnloading" type="danger" :title="$t('poorder.cancelorder')" size="mini" circle @click="handleUpdate(row)" />
          </template>
        </el-table-column>
        <!--      期次-->
        <el-table-column :label="$t('PoOrder.periodWeek')" prop="periodWeek" align="center" />
        <!--     订单编号 -->
        <el-table-column :label="$t('poOrder.orderNo')" prop="orderNo" align="center" />
        <!--     单据类型 -->
        <el-table-column :label="$t('fiAcInput.orderType')" prop="orderType" align="center" >
          <template v-slot="{row}">
            {{$lt(initDict.orderTyoe,row.orderType)}}
          </template>
        </el-table-column>
        <!--      经销商-->
        <el-table-column :label="$t('miMember.education0')" prop="memberName" align="center" />
        <!--      金额-->
        <el-table-column :label="$t('Account.money')" prop="totalAmount" align="center" />
        <!--      发货状态-->
        <el-table-column :label="$t('ai.sendinfo')" align="center">
          <template v-slot="{row}">
            {{$lt(initDict.sendStatus,row.sendStatus)}}
          </template>
        </el-table-column>
        <!--      收货状态-->
        <el-table-column :label="$t('pd.recStatus')" align="center">
          <template v-slot="{row}">
            {{$lt(initDict.recStatus,row.recStatus)}}
          </template>
        </el-table-column>
        <!--      换货积分-->
<!--        <el-table-column :label="$t('BiGoods.proPv')" prop="totalpointa0" align="center" />-->
        <!--      创建时间-->
        <el-table-column :label="$t('sys.createTime')" prop="createTime" align="center" />
        <!--      打印-->
        <el-table-column :label="$t('operation.button.print')" prop="" align="center" >
          <template v-slot="{row}">
            <el-button type="text" :loading="btnloading"  @click="Delhi(row)" >Delhi</el-button>
            <el-button type="text" :loading="btnloading"  @click="Other(row)" size="small">其他</el-button>
            <el-button  icon="el-icon-edit-outline" :loading="btnloading"  :title="$t('ru.other.goods')" size="mini" circle @click="othergoods(row)" />
          </template>
        </el-table-column>
      </el-table>
      <p style="font-weight: 600 ;color: green">{{this.$t('saFiIncomeReport.title.total') +'：'}}<span style="color:red;">{{this.totalAmountSum}}</span></p>
    </div>
  </div>
</template>

<script>
import {cancelOrders, orderList,orderListDetailExport} from "@/api/ay-business-manager/orderquery";
import {balanceSum} from "@/api/member";
import {mapGetters} from "vuex";
import {orderRecs, orderSends} from "@/api/po/order";

export default {
  name: "OrderQuery",
  data(){
    return{
      selectTableData: [],
      sjopen:false,
      btnloading: false,
      listLoading: false,
      BatchImportString: 0,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        companyCode: null
      },
      tableKey: 0,
      list: [],
      total: 0,
      canUseF$:0,
      totalAmountSum:0,
      wWeekList:null,
      companyCodelist: null,
      dcNoBuledialong:false,
      activeName:'first',
      initDict:{
        orderTyoe:'po.allordertype.cn',
        bdPeriodStatus:'pdmanifestsettle.receiptstatus',
        status: 'po.agengtorder.astatus',
        sendStatus: 'sysaftersale.sendflag',
        recStatus: 'pd.recstatus'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
    orderTyleList(){
      if(this.companyCode === "BD"){
        return this.$ll(this.initDict.orderTyoe).filter(ele => ele.code === '17' || ele.code === '19')
      }else{
        return this.$ll(this.initDict.orderTyoe)
      }

    },
    bdPeriodStatusList(){
      return  this.$ll(this.initDict.bdPeriodStatus)
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
  methods:{
    Delhi(row){
      this.$router.push({path: '/orderquery/printdetails', query:{id: row.id}})
    },
    Other(row){
      this.$router.push({path: '/orderquery/otherpages', query:{id: row.id}})
    },
    //  搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.btnloading = true
      this.listLoading = true
      this.totalAmountSum = 0
      orderList({ ...this.listQuery }).then(res => {
        if(res.data.records.length > 0){
          this.totalAmountSum = res.data.records[0].totalAmountSum
        }else{
          this.totalAmountSum = 0
        }
        this.list = res.data.records
        this.total = +res.data.total
        this.btnloading = false
        this.listLoading = false
      }).catch(err => {
        console.error(err)
        this.btnloading = false
        this.listLoading = false
      })
      balanceSum({...this.listQuery}).then(res=>{
        this.canUseF$ = res.data.canUseF$
      }).catch(err=>{
        console.error(err)
      })
    },
    handleView(row){
      this.btnLoading = true
      this.$router.push({name: 'ViewOrderquery', params:{ id: row.id } })
    },
    handleUpdate(row){
      let ids = []
      ids.push(row.id)
      this.$confirm(this.$t('fi.sure.handle'), '提示', {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        cancelOrders( ids ).then(() => {
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('operation.button.cancel')
        })
        this.btnloading = false
      })
    },
    // 代办处发货
    SendOut(){
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        orderSends(this.selectTableData).then(res => {
          console.log(res)
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('operation.button.cancel')
        })
        this.btnloading = false
      })
      console.log('代办处发货')
    },
    //经销商收货
    PutAway(row){
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        orderRecs(this.selectTableData).then(res => {
          console.log(res)
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('operation.button.cancel')
        })
        this.btnloading = false
      })
      console.log(row,'经销商收货')
    },
    handleSelectionChange(val) {
      this.selectTableData = []
      for (let i = 0; i < val.length; i++) {
        this.selectTableData = this.selectTableData.concat(val[i].id)
      }
    },
    selectable(row, ) {
      if(this.isAgent){
        return row.sendStatus !== 1
      }else {
        return row.recStatus !== 1
      }

    },
    othergoods(row){
      this.$router.push({name:'OrderQueryOthers',params:{id:row.id}})
    },
    // 导出
    exporttable() {
      this.btnloading = true
      orderListDetailExport({ ...this.listQuery }).then(response => {
        const lists = response.data
        for (let i = 0; i < lists.length; i++) {
          lists[i].orderType = this.$lt(this.initDict.orderTyoe, lists[i].orderType)
          lists[i].isGive =  lists[i].isGive == 0 ? this.$t('yesno.yes') : this.$t('yesno.no')
        }
        const tHeader = [this.$t('miAgent.agentNo'),this.$t('miMemberNetwork.memberNo'),this.$t('miMember.name'),
          this.$t('fiAcInput.orderType'),this.$t('PoOrder.periodWeek'),this.$t('Account.money'),this.$t('pmProductList.productId'),
            this.$t('stStock.goodsname'),this.$t('bigoods.pergoods.total'),
          this.$t('poOrder.count'),this.$t('bigoods.send.ornot'),this.$t('sys.createTime')]	// 表头
        const filterVal = ['agentNo','memberNo','memberName','orderType','periodWeek','totalAmount','goodsCode','goodsName','f$','quantity','isGive','createTime']	 // 对应json数据中的key，顺序与表头顺序一致
        // 远程请求要导出的数据
        const data = this.formatJson(filterVal, lists)
        import('@/vendor/Export2Excel').then(excel => {
          excel.export_json_to_excel({
            header: tHeader,	// 表头，必填
            data,	// 具体数据，必填
            filename: 'excelfilename',	// 导出文件名称，非必填
            autoWidth: true,	// 非必填
            bookType: 'xlsx'	// 非必填
          })
          this.btnloading = false
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
  }
}
</script>

<style scoped>

</style>
